import type { BrandingMode } from "$lib/caps";
import { getContext, setContext } from "svelte";
const context_key = {};

interface ShowContextProps {
	brandingMode?: BrandingMode;
	showSharingOptions: boolean;
	showTranslationOptions: boolean;
	showAccessibilityOptions: boolean;
	isTranslateView: boolean;
	showTOC: boolean;
	showViewCount: boolean;
	viewCount: number;
	hideShowPageTopBar: boolean;
	hasPolls?: boolean;
	newsletterId: string;
}

export function getShowContext(): ShowContextProps {
	return getContext(context_key) as ShowContextProps;
}

export function createShowContext(context: ShowContextProps): ShowContextProps {
	setContext(context_key, context);
	return context;
}
